import { Link, useLocation } from "react-router-dom";
import { FiBell, FiLogOut, FiMenu, FiSettings } from "react-icons/fi";
import HeaderUserAvatar from "components/header/HeaderUserAvatar";
import useAuth from "hooks/useAuth";
import useLogout from "hooks/useLogout";
import useSidebar from "hooks/useSidebar";
import { getDisplayName } from "lib/authUserDisplay";

const pageNames = {
  "/users": "Users",
  "/projects": "Projects",
  "/transactions": "Transactions",
  "/audit-log": "Audit Log",
  "/settings": "Settings",
  "/settings/profile": "Settings",
  "/settings/image": "Settings",
  "/settings/password": "Settings",
};

function resolvePageTitle(pathname) {
  if (pathname === "/") return "Users";
  if (pageNames[pathname]) return pageNames[pathname];
  if (pathname.startsWith("/settings")) return "Settings";
  return "Page";
}

export default function Header() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { logout } = useLogout();
  const { toggleMobile } = useSidebar();
  const displayName = getDisplayName(user);

  return (
    <header className="sticky top-0 z-20 border-b border-slate-200/80 bg-white/80 px-4 py-3 shadow-sm backdrop-blur md:px-6 lg:px-8">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <button
            onClick={toggleMobile}
            className="rounded-lg border border-slate-200 p-2 text-text-700 md:hidden"
            aria-label="Open sidebar"
          >
            <FiMenu />
          </button>
          <div className="flex items-center gap-2">
            <h2 className="text-lg font-bold text-text-900 md:text-xl">Back Office</h2>
            <div className="inline-flex rounded-full bg-accent-100 px-2 py-0.5 text-xs font-semibold text-brand-900">
              {resolvePageTitle(pathname)}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2 md:gap-3">
          <button className="rounded-lg border border-slate-200 p-2 text-text-700 transition hover:bg-slate-50">
            <FiBell />
          </button>
          <Link
            to="/settings"
            className="rounded-lg border border-slate-200 p-2 text-text-700 transition hover:bg-slate-50"
            aria-label="Settings"
          >
            <FiSettings />
          </Link>
          <Link
            to="/settings/profile"
            className="hidden items-center gap-2 rounded-xl border border-slate-200 bg-white px-2 py-1 transition hover:bg-slate-50 sm:flex"
            aria-label="Account settings"
          >
            <HeaderUserAvatar user={user} />
            <p className="max-w-[10rem] truncate text-sm font-semibold text-text-700">
              {displayName}
            </p>
          </Link>
          <button
            type="button"
            onClick={() =>  logout()}
            className="rounded-lg border border-slate-200 p-2 text-text-700 transition hover:bg-slate-50"
            aria-label="Logout"
          >
            <FiLogOut />
          </button>
        </div>
      </div>
    </header>
  );
}
